import { Button } from '../../../components/button'
import Modal from '../../../components/modal'

export default function ConfirmMembershipSuccess({ onClose, color }) {
  return (
    <Modal onClose={onClose}>
      <div className='wrapper'>
        <h1 className='title'>Your membership has been confirmed</h1>

        <Button className='confirm' onClick={onClose} color={color}>
          Close
        </Button>
      </div>

      <style jsx>{`
        .wrapper {
          position: relative;
          width: 43.6rem;
          padding: 2.6rem 2rem 4.1rem;
          background: #fff;
          border-radius: 1rem;
          text-align: center;
        }

        .title {
          text-align: center;
          font-size: 3.2rem;
          margin-bottom: 4rem;
        }

        .description {
          max-width: 26.6rem;
          margin: 0.7rem auto 2.6rem;
          text-align: center;
          font-size: 1.6rem;
        }

        @media (max-width: 1024px) {
          .wrapper {
            width: 100%;
            height: 100%;
            padding: 1.6rem 0 2.3rem;
          }

          :global(.confirm) {
            position: fixed;
            bottom: 2.1rem;
            left: 1.2rem;
            width: calc(100vw - 2.4rem);
          }
        }
      `}</style>
    </Modal>
  )
}
